module.exports = __webpack_public_path__ + "static/event4-665bcae1ceee7e39f6c6b5ec2efa8714.jpg";